<template>
  <main v-if="$page">
    <PageHeader :content="$page.header" />
    <ListSection :content="$page.option_key" list="products" />
    <ListSection :content="$page.option_business" list="products" />
    <ListSection :content="$page.option_employee" list="services" />
    <CTASection
      :content="$page.services"
      :link="$page.services_link"
      :page="$page.services_page"
      class="--light"
    />
  </main>
</template>

<script>
import CTASection from '@/components/sections/CTASection.vue'
import ListSection from '@/components/sections/ListSection.vue'
import PageHeader from '@/components/sections/PageHeader.vue'
import PageMetaMixin from '@/mixins/PageMetaMixin.js'

export default {
  name: 'HumanResources',
  beetPage: 'human_resources',
  mixins: [PageMetaMixin],
  components: { CTASection, ListSection, PageHeader },
}
</script>
